export default (xs, ys) =>
  xs
    .map((x) => ys.map((y) => [x, y]))
    .reduce((a, b) => a.concat(b), [])



// WEBPACK FOOTER //
// ./~/@klarna/ui/lib/combinations.js